import React from 'react'

export default function Copyright() {
    return (
        <div className="flex flex-wrap items-start justify-start md:justify-between">
            <div className="mx-auto w-full px-4 mt-14">
                <p className="font-normal text-sm text-COPYRIGHT_GRAY">
                    Healthy 2023 ©
                </p>
            </div>
        </div>
    )
}
